<template>
    <div class="welcome">
        <el-container>
            <el-header>
                <div class="men_btn" v-if="$store.state.type == 'mobile'" @click="navShow = ! navShow">
                    <img src="../assets/images/menu/menu.png" alt="">
                </div>
                <div class="logo">
                    <img src="../assets/images/logo/logo_w.png" @click="($route.name != 'home' && userInfo.permission) ? $router.push({name: 'home'}) : ''" alt="">
                </div>
                <div class="tabs" v-if="$store.state.type == 'pc'">
                    <div class="tab_item" :class="$route.name == item.path ? 'active' : ''" @click="routerGo(item)" v-for="item in $store.state.tags.slice(0,9)" :key="item.path + 123">
                        <p class="tab_name ellipsis" :title="item.name">{{item.name}}</p> 
                        <i class="el-icon-close" v-show="item.path!= 'home'" @click.stop="delTag(item)"></i>
                    </div>
                    <el-popover
                        ref="tagPop"
                        popper-class="popover"
                        placement="bottom-start"
                        trigger="hover">
                        <div class="act_box">
                            <p class=""  v-for="item in $store.state.tags.slice(9,$store.state.tags.length)" :key="item.path + 123">
                                <span class="ellipsis" @click="routerGo(item)">{{item.name}}</span>
                                <i class="el-icon-close close" v-show="item.path!= 'home'" @click.stop="delTag(item)"></i>
                            </p>
                        </div>
                        <div class="tabs_more" slot="reference" v-show="$store.state.tags.length > 9">
                            <span>更多</span>
                            <i class="el-icon-arrow-down"></i>
                        </div>
                    </el-popover>
                    
                </div>
                <div class="user">
                    <el-avatar :size="30" fit="fill"  :src="userInfo.avatar_url">
                        <img src="../assets/images/avatar.png"/>
                    </el-avatar>
                    <el-popover
                        popper-class="popover"
                        placement="bottom-start"
                        width="60"
                        v-if="type == 'browser' && $store.state.type == 'pc'"
                        trigger="click">
                        <div class="act_box">
                            <p @click="exit">退出</p>
                        </div>
                        <p class="name_box" slot="reference">
                            <span class="username">{{userInfo.name}}</span>
                            <i class="el-icon-caret-bottom"></i>
                        </p>
                    </el-popover>
                </div>
                <div class="menu_zz" v-show="menuShow"></div>
            </el-header>
            <el-container class="main">
                <el-aside width="106" v-show="navShow">
                    <div class="menu_box">
                        <div class="menu_item"   v-for="(val1, key1) in menu" :key="key1+'4234324'" @mouseover="menuSelect(val1)" @mouseleave="menuShowChange(false)">
                            <div class="menu_area" :class="{active: currentMenu.id == val1.id, select: (activeMenu.id == val1.id && menuShow)}">
                                <img class="menu_ico" :src="require(`../assets/images/menu/${val1.ico + (currentMenu.id == val1.id ? '-a' : '')}.png`)" alt="" >
                                <span class="menu_name">{{val1.name}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="submenu_area" v-show="menuShow">
                        <div class="submenu" @mouseover="menuShowChange(true)" @mouseleave="menuShowChange(false)">
                            <div class="submenu_item" v-for="item in activeMenu.menu" :key="item.id + 345">
                                <div class="submenu_title">{{item.name}}</div>
                                <div class="submenu_name_box">
                                    <div class="submenu_name" :class="$route.name == pages.path ? 'active' : ''" @click.stop="routerGo(pages)" v-for="pages in item.pages" :key="pages.path + '456'">
                                        <span>{{pages.name}}</span>
                                        <span class="creat_order" v-if="pages.path == 'order-manage' && roleCheck('101-102-101-103')" @click.stop="routerGoCreateOrder">
                                            <i class="el-icon-plus"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-aside>
                <el-main>
                    <div @click="closeMenu">
                        <keep-alive >
                            <router-view/>
                        </keep-alive>
                    </div>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import config from '../../package.json'
import Nav from '../../static/nav/nav.json'
export default {
    name: 'welcome',
    data() {
        return {
            userInfo: {},
            permission: [],
            type: '',
            routerName: '',
            menu: [],
            navShow: false,
            currentMenu: {},
            activeMenu: {},
            menuShow: false,
            timer: '',
            time: parseInt(localStorage.getItem('timer')) || 0,
            expires: parseInt(localStorage.getItem('expires') || 3600) - 600
        }
    },
    watch: {
        '$route': {
            handler(to) {
                if(this.$store.state.type == 'pc') {
                    this.navShow = true;
                }else{
                    this.navShow = false;
                }
                const title = this.$route.query.title ? this.$route.query.title : this.$route.meta.title;
                this.$store.commit('addTags', {name: title, path: this.$route.name, params: this.$route.params, query: this.$route.query});
                if(this.routerName == to.path.split('/')[1]) return;  //当前一级菜单无变化
                this.routerName = to.path.split('/')[1];
                this.menuFilter();
            },
            immediate: true
        }
    },
    beforeRouteEnter(to, form, next) {
        next(vm => {
            if(window.h5sdk) {
                vm.type = 'fs';
            }else{
                vm.type = 'browser';
            }
            if(new Date().getTime() - parseInt(localStorage.getItem('loginTime')) > (vm.expires + 500) * 1000) {
                if(vm.type == 'browser') {
                    vm.$message.error('登录状态失效，请重新登录!');
                }
                vm.exit();
                return;
            }
            vm.$store.commit('setToken', localStorage.getItem('token'));
            vm.getUserInfo();
        })
        
    },
    created() {
        if(this.$store.state.type == 'pc') {
            this.navShow = true;
        }
        let refreshNum = 0;
        this.timer = setInterval(() => {
            if(!localStorage.getItem('token') || !localStorage.getItem('loginTime') || refreshNum > 2) {
                this.$message.warning('登录状态失效，请重新登录！');
                this.exit();
                return;
            }
            if(new Date().getTime() - parseInt(localStorage.getItem('loginTime')) >= (this.expires * 1000)) { //刷新token
                refreshNum++;
                this.api.refreshToken({is_web: this.type == 'browser' ? true : false}).then(data => {
                    refreshNum--;
                    localStorage.setItem('token', data.data.access_token);
                    this.$store.commit('setToken', data.data.access_token);
                    localStorage.setItem('expires', (data.data.expiresIn || 3600));
                    localStorage.setItem('loginTime', new Date().getTime());
                })
            }
        },10000)
        window.addEventListener('beforeunload', e => this.beforeunloadFn(e));  //监听页面刷新，更新token存在时间
    },
    beforeDestroy() {
        clearInterval(this.timer);
        localStorage.removeItem('timer');
        window.removeEventListener('beforeunload', this.beforeunloadFn);
    },
    methods: {
        getUserInfo() {
            this.api.getUserInfo({}).then(data => {
                this.userInfo = data.data;
                if(!this.$route.query.version && config.version != this.userInfo.version) {  //页面版本不正确，刷新页面
                    let query = {...this.$route.query};
                    query.version = this.userInfo.version || config.version;
                    this.$router.replace({query: query});
                    this.$router.go(0);
                }
                this.permission = Array.from(new Set(this.userInfo.permission));
                localStorage.setItem('userInfo', JSON.stringify(data.data));
                this.$store.commit('updateUserInfo', data.data);
                this.getMenu();
            })
        },
        getMenu() {  //获取菜单数据
            this.menu = JSON.parse(JSON.stringify(Nav));  //深拷贝，防止修改menu时改变nav数据
            this.menuFilter();
        },
        menuFilter() {  // 过滤出当前显示菜单数据
            this.currentMenu = {};
            if(!this.userInfo.permission){
                return;
            }
            for(let k1 in this.menu) {
                if(this.menu[k1].id == this.routerName){
                    this.currentMenu = this.menu[k1];
                };
            }
            if(this.userInfo.role && this.userInfo.role.indexOf('系统管理员') != -1) {
                return;
            }
            for(let k1 in this.menu) {
                for(let k2 in this.menu[k1].menu) {
                    for(let k3 in this.menu[k1].menu[k2].pages) {
                        for(let k4 in this.menu[k1].menu[k2].pages[k3].permission) {
                            if(this.permission.indexOf(k4) == -1) { //没有该权限
                                this.$delete(this.menu[k1].menu[k2].pages[k3].permission, k4);
                                if(Object.keys(this.menu[k1].menu[k2].pages[k3].permission).length == 0) {  //用户没有该页面任何权限
                                    this.$delete(this.menu[k1].menu[k2].pages, k3);
                                    if(Object.keys(this.menu[k1].menu[k2].pages).length == 0) {  //用户没有该栏目任何权限
                                        this.$delete(this.menu[k1].menu, k2);
                                        if(Object.keys(this.menu[k1].menu).length == 0) {  //用户没有该菜单任何权限
                                            this.$delete(this.menu, k1);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        permissionRule(key) {
            let p = false;
            this.permission.forEach(item => {
                if(item.search(key) == 0) {
                    p = true;
                    return;
                }
            });
            return p;
        },
        menuSelect(menu) {
            this.activeMenu = menu;
            this.menuShowChange(true);
        },
        menuShowChange(v) {
            this.menuShow = v;
            this.$store.commit('setMenu', v);
        },
        closeMenu() {
            if(this.$store.state.type == 'mobile') {
                this.navShow = false;
            }
        },
        routerGoCreateOrder() {
            if(this.$route.name != 'create-order') {
                this.$router.push({name: 'create-order'});
                this.menuShow = false;
                this.activeMenu = {};
            }
        },
        routerGo(to) {   //点击菜单，路由跳转 
            if(to.path == this.$route.name || to.m_path == this.$route.name) return;
            const tag = this.$store.state.tags.find(item => item.path == to.path);
            if(tag) { //已打开过的页面
                this.$router.push({name: tag.path, params: tag.params, query: tag.query});
            }else{
                const path = this.$store.state.type == 'pc' ? to.path : (to.m_path || to.path);
                this.$router.push({name: path, params: to.params, query: to.query});
            }
            this.menuShow = false;
            this.activeMenu = {};
        },
        delTag(item) {  //删除tag
            this.$store.commit('delTags', item.path);
            if(this.$store.state.tags.length < 10) {
                this.$refs.tagPop.doClose();
            }
            if(item.path == this.$route.name) {
                this.$router.push({name: this.$store.state.tags[this.$store.state.tags.length - 1].path, params: this.$store.state.tags[this.$store.state.tags.length - 1].params, query: this.$store.state.tags[this.$store.state.tags.length - 1].query});
            };
        },
        exit() {
            this.$router.push({name: 'login'});
            localStorage.removeItem('token');
        }
    }
}
</script>
<style lang="less" scoped>
    .welcome{
        height: 100%;
        .el-container{
            width: 100%;
            height: 100%;
            &.main{
                height: calc(100% - 70px);
                position: relative;
            }
            .el-aside{
                background: #fff;
                height: 100%;
                position: relative;
                overflow: inherit;
                font-size: 14px;
                color: @colorGray;
                .menu_box{
                    margin-top: 20px;
                    .menu_item{
                        padding: 14px;
                        font-weight: 600;
                        cursor: pointer;
                        .menuA{
                            color: @colorBlue2;
                            background: rgba(80, 127, 247, .2);
                            border-radius: 9px;
                        }
                        &:hover{
                            .menu_area{
                                .menuA();
                                background: rgba(80, 127, 247, .1);
                                color: @colorGray;
                            }
                            
                        }
                        .menu_area{
                            padding: 5px 8px 5px 5px;
                            .flexLayout(flex-start);
                            &.select{
                                .menuA();
                                background: rgba(80, 127, 247, .1);
                                color: @colorGray;
                            }
                            &.active{
                                .menuA();
                            }
                            img{
                                width: 30px;
                                margin-right: 6px;
                            }
                        }
                        
                    }
                }
                .submenu_area{
                    position: absolute;
                    top: 0;
                    left: 105px;
                    width: 100vw ;
                    height: 100%;
                    z-index: 3000;
                    background: rgba(0,0,0,.4);
                    .submenu{
                        width: 210px;
                        height: 100%;
                        overflow: auto;
                        padding-top: 30px;
                        line-height: 40px;
                        box-sizing: border-box;
                        background: #fff;
                        .submenu_title{
                            padding-left: 20px;
                        }
                        .submenu_title{
                            color: @color333;
                            font-weight: 600;
                        }
                        .submenu_name_box{
                            padding-left: 25px;
                            .submenu_name{
                                padding-left: 15px;
                                cursor: pointer;
                                &:hover{
                                    color: @colorBlue2;
                                    // background-color: #F0F5FE;
                                    border-radius: 9px 0 0 9px;
                                }
                                &.active{
                                    color: @colorBlue2;
                                    background: #F0F5FE;
                                    border-radius: 9px 0px 0px 9px;
                                }
                                .creat_order{
                                    float: right;
                                    padding-right: 20px;
                                    font-weight: 600;
                                    font-size: 16px;
                                }
                            }
                        }
                    }
                }
                @media (max-width: 768px) {
                    position: absolute;
                    z-index: 9999;
                    box-shadow: 0px 4px 10px 0px rgba(103,113,130,0.1000);
                }
            }
            .el-header{
                height: 70px!important;
                padding-left: 0;
                color: #fff;
                background: #00172E;
                position: relative;
                .flexLayout(space-between);
                .logo{
                    width: 140px;
                    height: 70px;
                    background: #00172E;
                    .flexLayout();
                    img{
                        width: 110px;
                    }
                }
                .tabs{
                    height: 70px;
                    .flexLayout(flex-start, flex-end);
                    flex: 1;
                    font-size: 14px;
                    line-height: 1;
                    color: #868998;
                    .tab_item{
                        width: 8%;
                        padding: 10px 5px 8px;
                        border-radius: 12px 12px 0  0;
                        cursor: pointer;
                        
                        .flexLayout();
                        .tab_name{
                            width: 80%;
                            text-align: center;
                        }
                        &.active{
                            background: #fff;
                            color: @colorBlue;
                        }
                    }
                    .tabs_more{
                        width: 60px;
                        text-align: right;
                        line-height: 32px;
                        cursor: pointer;
                    }
                }
                .user{
                    .flexLayout(flex-start);
                    padding-bottom: 8px;
                    margin-bottom: -20px;
                    .name_box{
                        cursor: pointer;
                        .username{
                            margin: 0 8px;
                            font-size: 14px;
                        }
                    }
                }
                .menu_zz{
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 3000;
                    background: rgba(0,0,0,.4);
                }
                .men_btn{
                    width: 34px;
                    font-size: 20px;
                }
                @media (max-width: 768px) {
                    padding-left: 20px;
                    .user{
                        padding-bottom: 0;
                        margin-bottom: 0;
                    }
                }
            }
            .el-main{
                width: 100%;
                height: 100%;
                padding: 0;
                overflow: hidden;
                > div{
                    width: 100%;
                    height: 100%;
                }
                @media (max-width: 768px) {
                    overflow: auto;
                }
            }
        }
    }
    
</style>


// WEBPACK FOOTER //
// src/view/welcome.vue